const serviceName = "/Chat"

export function chatService(http){
    return {
        createGroup: (data) => {
            return http.post(serviceName + "/AddNewGroup", data)
        },
        getAllChats: (data) => {
            return http.get(serviceName + "/GetAllChats", data)
        },
        getGroupMessages: (data) => {
            return http.post(serviceName + "/GetGroupChats", data) 
        },
        getAllGroupParticipants: (data) => {
            return http.get(serviceName + "/GetAllGroupParticipants", data) 
        },
        saveParticipantMessage: (data) => {
            return http.post(serviceName + "/SaveMessage", data) 
        },
        deleteChatGroupWithMessages: (groupId) => {
            let params = { groupId }
            return http.post(serviceName + "/DeleteChatGroupWithMessagesAsync", params) 
        },
        getAllGroupMembers: (groupId) => {
            let params = { groupId }
            return http.post(serviceName + "/GetAllGroupMembers", params);
        },
        getAllChatGroupNamesAsync: (userId) => {
            let params = { UserId: userId }
            return http.post(serviceName + "/GetAllChatGroupNamesAsync", params);
        }
    }
}